import { getStandardizedOptions } from './utilities';
/**
 * provides a storage wrapper for session storage access
 */
export class SessionStorage {
    constructor(appName, storeName) {
        this.appName = appName;
        this.storeName = storeName;
    }
    /**
     * generates a unique key providing a minimal key scoping with appName and storeName,
     * enables to have the same key for different applications and stores.
     */
    getKey(key) {
        return `${this.appName}.${this.storeName}.${key}`;
    }
    static isSupported() {
        const key = `__test_key__`;
        try {
            sessionStorage.setItem(key, 'testValue');
            const supports = !!sessionStorage.getItem(key);
            sessionStorage.removeItem(key);
            return supports;
        }
        catch {
            return false;
        }
    }
    async set(key, value, expiryOrOptions) {
        const { expiry, persist } = getStandardizedOptions(expiryOrOptions !== null && expiryOrOptions !== void 0 ? expiryOrOptions : {});
        sessionStorage.setItem(this.getKey(key), JSON.stringify({ value, expiry, persist }));
    }
    getSync(key) {
        var _a;
        const result = (_a = sessionStorage.getItem(this.getKey(key))) !== null && _a !== void 0 ? _a : '{}';
        const { value } = JSON.parse(result);
        return value;
    }
    async get(key) {
        return this.getSync(key);
    }
    async getMany(keys) {
        return keys.reduce((valuesFromStorage, key) => {
            valuesFromStorage[key] = this.getSync(key);
            return valuesFromStorage;
        }, {});
    }
    async remove(key) {
        return sessionStorage.removeItem(this.getKey(key));
    }
    async clear() {
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if ((key === null || key === void 0 ? void 0 : key.includes(this.storeName)) && !this.isPersistent(key)) {
                sessionStorage.removeItem(key);
            }
        }
    }
    isPersistent(key) {
        var _a;
        const { persist = false } = JSON.parse((_a = sessionStorage.getItem(this.getKey(key))) !== null && _a !== void 0 ? _a : '{}');
        return persist;
    }
    async isExpired(key) {
        var _a;
        const { expiry } = JSON.parse((_a = sessionStorage.getItem(this.getKey(key))) !== null && _a !== void 0 ? _a : '{}');
        return typeof expiry === 'undefined' ? expiry : Date.now() >= expiry;
    }
    async getAllKeys() {
        const keys = Object.keys(sessionStorage).map((key) => key.toString().split(`${this.appName}.${this.storeName}.`)[1]);
        return keys;
    }
}
